
<template>
  <div>
     <v-layout wrap>
      <v-flex md3 xs12 >
     <SellerDashboard></SellerDashboard>
</v-flex>
      <v-flex md9 xs12>
     <v-card style="margin-left:20px; margin-right:20px;margin-top:20px;">
    <v-card-title >
      <b  class="prfont fontst">Add Tracking Id </b>
    </v-card-title>

    <!-- <br> -->
    <v-layout>
    <v-flex md3>
    </v-flex>
  <v-flex md6>
     
            <v-form ref="form">
            <v-text-field
             
              v-model="provider"
              prepend-icon="mdi-account"
              label="Provider"
              type="text"
             
              required
            />

            <v-text-field
             
              v-model="trackingid"
              prepend-icon="mdi-account"
              label="TrackingId"
              type="text"
             
              required
            />
             <v-text-field
             
              v-model="expecteddeliverydate"
              prepend-icon="mdi-account"
              label="Expected Delivery Date"
              type="date"
             
              required
            />
              <v-text-field
             
              v-model="remark"
              prepend-icon="mdi-account"
              label="Remarks"
              type="texts"
             
              required
            />
          
          
         

            <v-layout wrap justify-center>
              <v-flex xs12 md12 pt-2 text-center>
                <v-btn
                  rounded
                  :disabled="false"
                  width="500px"
                  class="text-capitalize hh"
                  dark
                  :ripple="false"
                  color="#ff4e00"
                  @click="reginit"
                >SUBMIT</v-btn>
              </v-flex>
            </v-layout>
            <br />

          
          </v-form>
  </v-flex>
    </v-layout>   
      
     </v-card>
      </v-flex>
      
    <br />
    </v-layout>
  </div>
</template>
<script>
import StarRating from "vue-star-rating";
import axios from "axios";
import AppSideNav from "@/components/common/AppSideNav";
import SellerDashboard from "@/components/common/SellerDashboard";

export default {
 props:["id"],
  components: {
    AppSideNav,
    StarRating,
    SellerDashboard
  },
  data() {
    return {
       
     provider:null,
     trackingid:null,
     expecteddeliverydate:null,
     remark:null
    };
  },
 
  methods: {
     reginit() {
      
        var datas = {};
        datas["id"]=this.id;
        datas["provider"] = this.provider;
        datas["trackingid"] = this.trackingid;
        datas["expecteddeliverydate"] = this.expecteddeliverydate;
        datas["remark"] = this.remark;
      
        // this.dialog = false;
        axios({
          method: "POST",
          url: "/purchase/addtracking/",
          data: datas,
             headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        })
          .then(response => {
            if (response.data.status == true) {
              this.msg = "successfully added";
              this.$dlg.alert(
                this.msg,
                () => {
                  this.$router.push("/SellerPurchase/");
                },
                { messageType: "success" }
              );
            } else {
              this.msg = response.data.msg;
              this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
            }
          })
          .catch(e => {
            this.msg = "Not Success";
            this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
          });
      
    }   
  }
};
</script>

<style scoped>
.prfont{
  font-family: 'Montserrat';
}
</style>